import gsap from 'gsap'
import { Parallax } from '@/helpers/parallax'

export class Slides {

    static selectors() {
        const textSelectors = ['.is-active .slide__title', '.is-active .slide__text-el']

        return document.querySelector('.slide__splash')
            ? [
                textSelectors,
                ['.slides .slide__splash__img'],
            ] : [
                textSelectors,
            ]
    }
    
    static updatePageMeta(slide, alias, titles, isEntry = false) {
        if ( !Array.isArray(titles) || typeof titles[slide] === undefined ) return;

        document.title = `Doane Grant Thornton | ${titles[slide]}`

        if ( isEntry && Array.isArray(alias) ) {
            window.history.pushState( slide, '', alias[slide])
            // vm.$router.push({ path: alias[slide] })
        }
    }

    static setMainOffset({
        slides,
        offset, 
        method = 'to', 
        duration = null, 
        onComplete = null
    }) {

        const slidesAttrs = {
            x: offset,
            duration,
            ease: 'strong.inOut',
        }

        if (typeof onComplete == 'function') {
            slidesAttrs.onComplete = onComplete()
        }
        
        gsap[method]( slides, slidesAttrs )
    }

    static setElemsOffset({
        slides,
        currentSlide,
        isDiscover,
        delta,
        method = 'fromTo',
        duration = null,
    }) {
        return setTimeout(() => {
    
            Parallax[method](...Parallax.getElems({
                elems: Slides.selectors( isDiscover ),
                slides, 
                currentSlide, 
                delta, 
            }))
    
        }, (duration * 1000 / 3))
    }
}